import { appendSlash } from './utils/appendSlash.js';
const URI_KEYS = ['CDN', 'BASE_PATH'];
export const projectSettings = new Proxy({
    _: {},
    setup(_) {
        this._ = _;
    },
}, {
    get(target, p) {
        const result = target._[p] || target[p];
        return URI_KEYS.includes(p) ? appendSlash(result) : result;
    },
});
//# sourceMappingURL=ProjectSettings.js.map